<template>
  <div class="comp-templates">
    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black" @click="showModalAdd = true">+ New Email Template</button>
      </div>
      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH TEMPLATES..." v-model="keyword"
                 @change="doPaging(1)">
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th width="120"><a href="javascript:;">TEMPLATE ID</a></th>
          <th width="120"><a href="javascript:;">NAME</a></th>
          <th><a href="javascript:;">SUBJECT</a></th>
          <th><a href="javascript:;">FROM NAME</a></th>
          <th><a href="javascript:;">FROM EMAIL</a></th>
          <th width="40"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(template, index) in templates" :key="index" @click="gotoTemplate(template.id)" style="cursor: pointer;">
          <td>#{{ template.id }}</td>
          <td>{{ template.name }}</td>
          <td>{{ template.email_subject }}</td>
          <td>{{ template.from_name }}</td>
          <td>{{ template.from_email }}</td>
          <td class="text-right actions">
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete template'"
               @click="confDelete(index)"></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="hasFilters && templates.length == 0" class="alert alert-warning">
      No templates found
    </div>
    <div class="d-flex justify-content-between">
      <div class="actions"></div>
      <pagination :total-pages="totalPages" :current-page="currentPage" @goto-page="doPaging"></pagination>
    </div>

    <modal-add-template v-model="showModalAdd" @added="onTemplateAdded"></modal-add-template>
  </div>
</template>

<script>
  import ServiceTemplate from '@/services/emailtemplate'
  import ModalAddTemplate from './ModalAddTemplate'

  export default {
    components: {
      ModalAddTemplate
    },
    data() {
      return {
        showModalAdd: false,
        keyword: '',
        activeIndex: -1,
        totalItems: 0,
        currentPage: 1,
        totalPages: 0,
        templates: []
      }
    },
    watch: {
    },
    computed: {
      hasFilters() {
        let self = this;
        return self.keyword != '';
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalAdd = false;
        this.getTemplates();
      },
      gotoTemplate(templateId) {
        this.$router.push({name: 'settings-email-template', params: {templateId: templateId}});
      },
      onTemplateAdded(template) {
        let self = this;
        self.$router.push({
          name: 'settings-email-template',
          params: {
            templateId: template.id
          }
        });
      },
      confDelete(index) {
        let self = this, item = self.templates[index];
        self.$dialog
          .confirm('Are you sure you want to delete email template #<strong>' + item.id + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceTemplate.delete(item.id, () => {
              dialog.close();
              self.templates.splice(index, 1);
              self.$notify({
                type: 'success',
                text: 'Template <strong>' + item.name + '</strong> has been deleted'
              });
            });
          })
          .catch(() => {
          })
        ;
      },
      doPaging(page) {
        let self = this;
        self.currentPage = page;
        self.getTemplates();
      },
      getTemplates() {
        let self = this,
          params = {
            page: self.currentPage,
          };

        if (self.keyword !== '') {
          params.kw = self.keyword;
        }

        self.state = 'loading';
        ServiceTemplate.getEmailTemplates(params, resp => {
          self.state = 'loaded';
          self.templates = resp.data;
          self.totalPages = resp.last_page;
          self.totalItems = resp.total;
        });
      }
    }
  }
</script>
